var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.position")) +
                " > " +
                _vm._s(_vm.position.name) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _vm.hasRoleDelete
                      ? _c("BaseActionDropdown", {
                          attrs: {
                            icon: "fas fa-cog",
                            text: _vm.$t("button.options"),
                            items: [
                              {
                                icon: "fas fa-trash",
                                iconClassName: "text-danger",
                                text: _vm.$t("button.delete"),
                                textClassName: "text-danger",
                                value: "delete"
                              }
                            ]
                          },
                          on: { onSelect: _vm.handleSelectOption }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("HrmPositionForm", {
            attrs: {
              state: _vm.position,
              isSubmitted: _vm.isSubmitted,
              employees: _vm.employees,
              disabled: _vm.disabled || !_vm.hasRoleEdit,
              form: _vm.form,
              showActionButtons: _vm.hasRoleEdit
            },
            on: {
              "update:form": function($event) {
                _vm.form = $event
              },
              onSubmit: _vm.handleSubmit
            }
          }),
          _vm._v(" "),
          _c("baseConfirmDeleteModal", {
            attrs: { show: _vm.modal.show, loading: _vm.modal.loading },
            on: {
              onClose: _vm.handleCloseModal,
              onCancel: _vm.handleCancleModal,
              onSubmit: _vm.handleSumitModal
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff8a81d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff8a81d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/hrm/position/Edit.vue
// module id = null
// module chunks = 